import { axiosMeedioClient } from '../client';

/**
 * Revokes an API key. The backend returns `204 No Content` and is idempotent —
 * an already-revoked key also resolves as success.
 */
export const revokeApiKey = async (workspaceId: string, keyId: string): Promise<void> => {
  await axiosMeedioClient.delete(`/v1/workspaces/${workspaceId}/api-keys/${keyId}`);
};
